module.exports = __webpack_public_path__ + "static/media/menninger-clinic.66ac1583.png";